































import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldSearchAddress'

  vue:
    props: ['value', 'errors', 'placeholder', 'disabled']

    data: ->
      value_: @value

    methods:
      hiInputChange: (k, v) ->
        @value[k] = "#{v}".replace(/[a-zA-z]/g, '')
        @$emit 'input', @value

    watch:
      value: (v) ->
        @value_ = v

export default VueOptions.vue settings
